import * as React from "react"
import {AutocompleteSeeker} from "@ui-seeker/core"

import {productDetailsEvolutionOptionsSku, productDetailsEvolutionSelectedSku} from "../../@signals";


export default function MarketplacesProductDetailsEvolutionSkuAutocomplete() {

	return <AutocompleteSeeker
		disableClearable
		label="SKUs"
		placeholder="Search SKU..."
		options={productDetailsEvolutionOptionsSku.value}
		value={productDetailsEvolutionSelectedSku.value}
		onChange={e => productDetailsEvolutionSelectedSku.value = e.target.value}
	/>
}